import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectorRef, ElementRef, Input, Output, Pipe, PipeTransform, EventEmitter , ViewEncapsulation } from '@angular/core';

import { FiltersService } from '../../services/filters.service';
import { OrdersService } from '../../services/orders.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { UntypedFormControl } from '@angular/forms';
import { GlobalsService } from 'app/services/globals.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'app-item-filters',
	templateUrl: './item-filters.component.html',
	styleUrls: ['./item-filters.component.scss'],
})
export class ItemFiltersComponent implements OnInit {
	@Input() items;
	@Input() keywords;
	@Input() limit;
	@Input() customer;
	@Output() itemupdate = new EventEmitter < any > ();
	@Output() filtersSelected = new EventEmitter < any > ();
	@Output() clearAll = new EventEmitter < any > ();
	@ViewChild('productlineFilter') prodlineFilterRef: ElementRef;

	filters: any[];
	config: any = false;
	inventorysearching: any = false;
	search_items: any = [];
	selected_filters = [];
	filtered_items: any;
	selected_checks = [];
	issalesman = false;
	filteredOptions: any = [];
	linesearchref = new UntypedFormControl('');
	filtergroupid: any = false;
	prods: any = [];
	productLineCheckBoxFilter: any = false;
	showlines: any = false;
	client: any = false;

	constructor( private modalService: NgbModal, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, private filtersService: FiltersService, private ordersService: OrdersService) {
		this.filtered_items = this.items;
	
		this.globalSearchService.configsubscription.subscribe(r => {
			this.config = r;
			this.client = r.env.client;
			this.globalSearchService.user.subscribe(u => {
				if (u.user.issalesman) {
					this.issalesman = true;
				}
			});
		});
	}

	ngOnInit(): void {
		this.filtersService.getFilters().subscribe((results: any) => { 
			this.filters = results; 
		});

		this.filtered_items = this.items;

		this.linesearchref.valueChanges.subscribe((newv) => {
			this.filterProductLines(newv);
		})
	}



	applyFilters() {
		this.itemFilter();
	}

	updateChecks(event: any, filter_id: any) {

		if (!this.selected_checks[filter_id]) {
			this.selected_checks[filter_id] = [];
		}

		const data = { value: event.source.value };

		if (event.checked) {
			this.selected_checks[filter_id].push(data)
		} else {

			const index = this.selected_checks[filter_id].indexOf(data);


			this.selected_checks[filter_id] = this.selected_checks[filter_id].filter((selected, index) => {
				return selected.value != event.source.value
			});
		}
		//prevent empty send
		if(this.selected_checks[filter_id].length) {
			this.selected_filters[filter_id] = { filter_id: filter_id, value: this.selected_checks[filter_id] };
		} else {
			this.selected_filters[filter_id] = {};
		}


	}

	searchOptions(options: any[], searchTerm: string) {
		const lowerCaseTerm = searchTerm.toLowerCase();
		this.filteredOptions = options.filter(option =>
		  option.label.toLowerCase().includes(lowerCaseTerm)
		);
	  }


	updateSearchSelect(event: any, filter_id: any) {
		this.filtered_items = this.items;
		if(event.value != 'reset'){
			this.selected_filters[filter_id] = { filter_id: filter_id, value: event.value };
		} else {
			this.selected_filters[filter_id] = {};
		}

	}

	itemFilter() {
		const data = { keywords: this.keywords, limit: this.limit, customer: this.customer, filters: this.selected_filters };
		this.itemupdate.emit(data)
		this.filtersSelected.emit(this.selected_filters)
	}

	resetFilters(){
		this.filtersService.getFilters().subscribe((results: any) => { this.filters = results; });
		this.selected_checks = [null, {}];
		this.selected_filters = [];
		this.prods = [];
		this.linesearchref.setValue('');
		this.clearAll.emit(this.selected_filters)
	}

	resetProdlines(){
		//used to restet product line selections - leaves other filters alone
		this.linesearchref.setValue('');
		this.selected_checks[this.productLineCheckBoxFilter] = [];
		this.selected_filters[this.productLineCheckBoxFilter] = [];
		
		this.filters.map((filter) => {
			if(filter.filter_id == this.productLineCheckBoxFilter){
				filter.optionsfull.forEach((opt) => {opt.checked = false})
				filter.options.forEach((opt) => {opt.checked = false})
			}
		})
		this.clearAll.emit(this.selected_filters);
	}

	updateProductLinesFromModal($event){
		this.prods = $event;
	}

	displayLines(value){
		setTimeout(() => {
			this.showlines = value;
		},1000)
	}


	//salesman product line view - modal & chips
	openProductLines(){
		const filterindex = this.filters.filter((i) => {
			return i.input_type == 'modal' && i.name === 'Product Line';
		})[0]['filter_id'];

		this.modalService.open(this.prodlineFilterRef, { ariaLabelledBy: 'modal-basic-title', size: 'xl' }).result.then((result) => {

		}, (reason) => {
			if(this.prods.length){
				(this.prods).forEach((prodline) => {
					this.updateChecks({ source:{ value: prodline.line_field }, checked: true }, filterindex);
				})
			}else{
				this.selected_checks[filterindex] = [];
				this.selected_filters[filterindex] = [];
			}
		});
	}

	//BOF product line view - checkboxes
	filterProductLines(input){ 
		const filtername = this.client == 'aaprod' ? 'Manufacturer' : 'Product Line';
		
		this.filters.forEach((f) => {
			if(f.name === filtername && f.input_type == 'checkbox'){
				this.productLineCheckBoxFilter = f.filter_id;
				let batchadd = false;
				if(!f.optionsfull){
					f['optionsfull'] = f['options'];
				}
				if(input.charAt(input.length -1) === '*' && f.options.length){
					f.optionsfull.forEach(filter => {
						if(f.options.indexOf(filter) > -1){
							let checked = true;
							if(filter.checked == '1' || filter.checked === true){
								checked = false;
							}
							f.options[f.options.indexOf(filter)]['checked'] = checked;
							filter['checked']= checked;
							this.updateChecks({ source:{ value: filter.value }, checked: filter['checked'] }, f.filter_id);
						}
					});
					
					batchadd = true;
				}

				if(!batchadd){
					if(input === ''){
						f.options = f.optionsfull;
					}else{
						f.options = f['optionsfull'].filter((i) => {
							return (i.label +'+'+ i.value).toUpperCase().includes((input).toUpperCase());
						})
					}
				}

			}
		})
	}

}
